import { HEAT_ORDER, HEAT_SWATCH, heatPaint } from './heatmapData.js'

/** The heatmap's key: the five states, then how time is drawn. */
export function HeatLegend({ unreleased = false }: { unreleased?: boolean }) {
  const ahead = heatPaint('covered', 'ahead')
  const grey = heatPaint('none', 'unreleased')
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[11px] text-ink-mid">
      {HEAT_ORDER.map((state) => (
        <span key={state} className="inline-flex items-center gap-1.5">
          <span aria-hidden="true" className="h-3 w-3 rounded-sm" style={{ background: HEAT_SWATCH[state].fill }} />
          {HEAT_SWATCH[state].label}
        </span>
      ))}
      <span className="inline-flex items-center gap-1.5">
        <span aria-hidden="true" className="h-3 w-3 rounded-sm" style={{ background: ahead.background, border: ahead.border }} />
        Striped: still ahead
      </span>
      {unreleased && (
        <span className="inline-flex items-center gap-1.5">
          <span aria-hidden="true" className="h-3 w-3 rounded-sm" style={{ background: grey.background, border: grey.border }} />
          Not released
        </span>
      )}
    </div>
  )
}
